<script lang="ts">
  export let svgStyles: string = ''
</script>

<svg width="375" height="444" viewBox="0 0 375 444" fill="none" xmlns="http://www.w3.org/2000/svg" class={svgStyles}>
  <path
    d="M408.5 222C408.5 344.329 308.885 443.5 186 443.5C63.1145 443.5 -36.5 344.329 -36.5 222C-36.5 99.671 63.1145 0.5 186 0.5C308.885 0.5 408.5 99.671 408.5 222Z"
    stroke="#272D37"
  />
</svg>
